import { Button, Form as BTForm } from "react-bootstrap";
import Card from "../../../../components/Cards/Basic";
import { FieldArray, Form, Formik } from "formik";
import FormInputText from "../../../../components/Forms/FormInputText";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../../config/axios";
import { showSuccessToast } from "../../../../components/Toasts";
import history from "../../../../global/history";
import BackButton from "../../../../components/UiComponents/Buttons/BackButton";
import { linkBuilder } from "../../../../global/navigationHelper";
import EditInvoiceForm from "../../EditInvoiceForm";

const EditOnlineReservationInvoicePage = () => {
  const { online_reservation_id, id } = useParams();
  const [invoice, setInvoice] = useState();
  const formRef = useRef();

  useEffect(() => {
    if (id) {
      getInvoice();
    }
  }, []);

  function getInvoice() {
    axios.get(`/api/v1/invoices/${id}.json`).then(function (response) {
      setInvoice(response.data);
    });
  }

  function updateInvoice(data) {
    if (id) {
      axios
        .put(`/api/v1/invoices/${id}.json`, { invoice: data })
        .then(function (response) {
          setInvoice(response.data);
          showSuccessToast();
          history.push(`/dashboard/reservations/${online_reservation_id}`);
        });
    } else {
      axios
        .post(
          `/api/v1/online_reservations/${online_reservation_id}/invoices.json`,
          { invoice: data }
        )
        .then(function (response) {
          setInvoice(response.data);
          showSuccessToast();
          history.push(`/dashboard/reservations/${online_reservation_id}`);
        });
    }
  }

  if (!invoice) {
    return <></>;
  }

  return (
    <Card
      title={
        <div className={"d-flex align-items-center"}>
          <BackButton
            fallbackRoute={linkBuilder(
              "/dashboard/reservations/" + online_reservation_id
            )}
          />
          <span>Reservierungen</span>
        </div>
      }
      footer={
        <div>
          <Button
            variant="primary"
            className={"mr-1"}
            onClick={() => formRef?.current?.handleSubmit()}
            disabled={formRef?.current?.isSubmitting}
          >
            Speichern
          </Button>
        </div>
      }
    >
      <EditInvoiceForm
        formRef={formRef}
        invoice={invoice}
        handleSubmit={updateInvoice}
      />
    </Card>
  );
};

export default EditOnlineReservationInvoicePage;
